export default "__VITE_ASSET__4a8e4910__"